import React from 'react';
import {Box, Button, Grid, TableContainer} from "@mui/material";
import NoMatchingInvoicesFound from '../../NoMatchingInvoicesFound';
import Table from "../../deprecatedUikit/Table/Table";

const supplierHeaderCells = [
  {
    id: 'orderNumber',
    label: 'Booking #'
  },
  {
    id: 'status',
    label: 'Status'
  },
  {
    id: 'buyerName',
    label: 'Buyer Name'
  },
  {
    id: 'reason',
    label: 'Buyer Response'
  },
  {
    id: 'dateOfSubmission',
    label: 'Date Of Submission'
  }
];

const buyerHeaderCells = [
  {
    id: 'orderNumber',
    label: 'Booking'
  },
  {
    id: 'status',
    label: 'Status'
  },
  {
    id: 'supplierName',
    label: 'Supplier Name'
  },
  {
    id: 'locationName',
    label: 'Location Name'
  },
  {
    id: 'rejectionReason',
    label: 'Rejection Reason'
  },
  {
    id: 'dateOfSubmission',
    label: 'Date Of Submission'
  },
  {
    id: 'equipmentNumber',
    label: 'Equipment Number'
  }
];

const InventoryCorrectionsTable = (props) => {
  const classes = {
    rejectionReason: 'ss-rejection-reason'
  }

  const {inventoryCorrections, handleReviewItem, isSupplier} = props;
  const buttonText = isSupplier ? 'Review' : 'View';

  const actionButtons = (item) => {
    return <Grid container sx={{ fontSize:'1em' }}>
      <Button sx={{ fontSize:'1em' }} onClick={() => handleReviewItem(item)} variant="outlined">{buttonText}</Button>
    </Grid>
  }

  return (
    <TableContainer>
      {inventoryCorrections.length === 0 ?
        <NoMatchingInvoicesFound
          message={'You have no inventory corrections yet.'}
        /> :
          <Box mt={4} sx={{
            ...(inventoryCorrections.length === 0) && {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh'
            }
          }}>
            <Table
              headCells={isSupplier ? supplierHeaderCells : buyerHeaderCells}
              rows={inventoryCorrections}
              hasRowAction={true}
              actionType='button'
              actionButtons={actionButtons}
              rowClasses={classes}
            />
          </Box>
        }
        </TableContainer>
  )
};

export default InventoryCorrectionsTable;
